import { Divider, type DividerProps } from '@chakra-ui/react';
import { type FC } from 'react';

export const SidebarDivider: FC<DividerProps> = (props) => {
  return <Divider my='0 !important' borderColor='border' {...props} />;
};
